import {
  Timestamp,
  type DocumentData,
  type DocumentSnapshot,
  type QueryDocumentSnapshot,
} from 'firebase/firestore'
import type { PdHackCategory } from '@domain/models/pd-hacks'

function toOptionalDate(value: unknown): Date | undefined {
  if (value instanceof Timestamp) {
    return value.toDate()
  }
  if (value instanceof Date) {
    return value
  }
  return undefined
}

function toBoolean(value: unknown): boolean | undefined {
  if (typeof value === 'boolean') {
    return value
  }
  if (typeof value === 'string') {
    if (value.toLowerCase() === 'true') {
      return true
    }
    if (value.toLowerCase() === 'false') {
      return false
    }
  }
  return undefined
}

export function fromFirestorePdHackCategory(
  docSnap: DocumentSnapshot<DocumentData> | QueryDocumentSnapshot<DocumentData>,
): PdHackCategory {
  const data = (docSnap.data() ?? {}) as Record<string, unknown>
  const createdAt = toOptionalDate(data['created_at']) ?? toOptionalDate(data['createdAt'])
  const isActive = toBoolean(data['is_active']) ?? toBoolean(data['isActive']) ?? false

  return {
    uid: docSnap.id,
    name: typeof data['name'] === 'string' ? data['name'] : '',
    createdAt,
    isActive,
  }
}
